import styled from 'styled-components'
import { Button, Flex, getPaletteColor } from 'pcln-design-system'

const StyledMenuButton = styled(Button)`
  > ${Flex} {
    justify-content: left;
  }
  position: relative;
  height: 56px;
  padding: 0px;
  &:focus-visible {
    outline: solid 3px ${getPaletteColor('primary.base')};
  }
`

export default StyledMenuButton
